import { useCustomPreferences } from '../utils/api';
import { CustomPreference } from '../utils/api/CustomPreference';
import { useABTestVariable } from './useABTestVariable';

export type ShippingProtectionTestMode = 'ON_DEFAULT_ON' | 'ON_DEFAULT_OFF' | null;

type UseShippingProtectionConfigsResult = {
    /** Should UI (toggle/perks) be visible? Requires feature flag and mode if AB is enabled */
    isUIVisible: boolean;
    /** Should default behavior (auto-add) be active? Requires feature flag and then:
     * - if AB test enabled: ON_DEFAULT_ON
     * - else: shippingProtectionDefaultBehavior pref
     */
    isDefaultBehaviorActive: boolean;
};

export const useShippingProtectionConfigs = (): UseShippingProtectionConfigsResult => {
    const customPreferences =
        useCustomPreferences([
            CustomPreference.SHIPPING_PROTECTION_ENABLED,
            CustomPreference.SHIPPING_PROTECTION_DEFAULT_BEHAVIOR,
            CustomPreference.SHIPPING_PROTECTION_AB_TEST_MODE,
        ]) ?? {};

    const isFeatureEnabled =
        (customPreferences[CustomPreference.SHIPPING_PROTECTION_ENABLED] as boolean) ?? false;
    const shippingProtectionDefaultBehavior =
        (customPreferences[CustomPreference.SHIPPING_PROTECTION_DEFAULT_BEHAVIOR] as boolean) ??
        false;
    const isABTestEnabled =
        (customPreferences[CustomPreference.SHIPPING_PROTECTION_AB_TEST_MODE] as boolean) ?? false;

    const mode = useABTestVariable<ShippingProtectionTestMode>(
        CustomPreference.SHIPPING_PROTECTION_AB_TEST_MODE,
        null,
    );

    const isUIVisible =
        isFeatureEnabled &&
        (!isABTestEnabled || mode === 'ON_DEFAULT_ON' || mode === 'ON_DEFAULT_OFF');
    const isDefaultBehaviorActive =
        isFeatureEnabled &&
        (isABTestEnabled ? mode === 'ON_DEFAULT_ON' : shippingProtectionDefaultBehavior);

    return {
        isUIVisible,
        isDefaultBehaviorActive,
    };
};
